import {inject, provideAppInitializer} from '@angular/core';
import {HealthCheckService} from '../service/health-check.service';

export const HEALTH_CHECK_PROVIDER = () => {
  return provideAppInitializer(() => {
    const initializerFn = ((healthCheckService: HealthCheckService) => {
      return () => {
        healthCheckService.init();
      }
    })(inject(HealthCheckService));
    return initializerFn();
  });
}
